// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qIMW","field":"styles_field__1RkfJ","fieldCol":"styles_fieldCol__2AbpM","diffCol":"styles_diffCol__Fcl9U","diff":"styles_diff__s_ogW"};